import { makeQueryOptions } from '@mint-lib/api-zod-support/react-query';

import { defaultApi } from '@mint-sdk/api-core';

import { PlatformsQuerySchema, PlatformsResponseSchema } from './schemas.js';

export const list = defaultApi.declareEndpoint({
  url: 'bff/v2/platforms/',
  method: 'GET',
  querySchema: PlatformsQuerySchema,
  responseSchema: PlatformsResponseSchema,
  snakeCaseQueryParams: true,
});

export const listQueryOptions = makeQueryOptions(list, {
  processResponse(data) {
    return data;
  },
});
